import styled from 'styled-components';

const AreaInfoEditPopupContainer = styled.div`
  background: #272f3c;
  border-radius: 10px;
  padding: 10px;

  & > div {
    padding: 0.2rem 1rem;
  }

  & > form {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;

    & > div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 400px;

      & > div.info-column {
        width: 150px;
        text-align: left;
      }
      & > div.info-value {
        width: 250px;
        text-align: center;

        & > input {
          width: 250px;
        }
      }
    }

    & > div.btn-box {
      width: 100%;
      margin-top: 1rem;
    }
  }
`;

export default AreaInfoEditPopupContainer;
